module.exports = __webpack_public_path__ + "img/close.ac8f9a3a.svg";